import React, { createContext, useContext } from 'react';

interface BaseModalContextValue {
    onClose: () => void;
}

export const BaseModalContext = createContext<BaseModalContextValue | null>(null);

export const useBaseModal = () => {
    const context = useContext(BaseModalContext);
    if (!context) {
        throw new Error('useBaseModal must be used within a BaseModalProvider');
    }
    return context;
};

interface BaseModalProviderProps {
    onClose: () => void;
    children: React.ReactNode;
}

export const BaseModalProvider: React.FC<BaseModalProviderProps> = ({ 
    onClose, 
    children 
}) => {
    return (
        <BaseModalContext.Provider value={{ onClose }}>
            {children}
        </BaseModalContext.Provider>
    );
};
